/**
 * @generated SignedSource<<33ed70a0a4c626b58f9c622b96e6f5cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TicketChannel = "manual" | "email" | "phone" | "chat" | "internal" | "api" | "customer_portal" | "direct" | "%future added value";
export type TicketPriority = "p0" | "p1" | "p2" | "p3" | "%future added value";
export type TicketStatus = "open" | "in_progress" | "waiting_on_customer" | "resolved" | "closed" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type TicketDetailHeader_ticket$data = {
  readonly id: string;
  readonly subject: string;
  readonly description: string | null;
  readonly status: TicketStatus;
  readonly priority: TicketPriority;
  readonly channel: TicketChannel;
  readonly slug: string;
  readonly number: number;
  readonly createdAt: string;
  readonly assigneeId: string | null;
  readonly isWatching: boolean;
  readonly watcherCount: number | null;
  readonly ticketTimeRegistrations: ReadonlyArray<{
    readonly id: string;
    readonly minutesRegistered: number | null;
    readonly billableMinutesRegistered: number | null;
  }>;
  readonly sla: {
    readonly breached: boolean;
    readonly elapsedSeconds: number;
    readonly thresholdSeconds: number;
    readonly paused: boolean;
  };
  readonly requester: {
    readonly name: string;
  } | null;
  readonly " $fragmentType": "TicketDetailHeader_ticket";
};
export type TicketDetailHeader_ticket$key = {
  readonly " $data"?: TicketDetailHeader_ticket$data;
  readonly " $fragmentSpreads": FragmentRefs<"TicketDetailHeader_ticket">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TicketDetailHeader_ticket",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subject",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priority",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "channel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "number",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "assigneeId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isWatching",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "watcherCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TimeRegType",
      "kind": "LinkedField",
      "name": "ticketTimeRegistrations",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minutesRegistered",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "billableMinutesRegistered",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TicketSla",
      "kind": "LinkedField",
      "name": "sla",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "breached",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "elapsedSeconds",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "thresholdSeconds",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "paused",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Requester",
      "kind": "LinkedField",
      "name": "requester",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Ticket",
  "abstractKey": null
};
})();

(node as any).hash = "7d09de4ae856d80cf848a81a1f24c2e7";

export default node;
